import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Certification, Download, Info, Phone, Vector } from '../../../ui/icons';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getMainVideo } from "../../../store/courseSlice";

const SidebarContainer = styled.div`
    width: 30%;
    @media(max-width: 1032px) {
        width: 100%;
    }
`;

const SidebarWrapper = styled.div`
    background: #0A1F44;
    padding: 24px;
    border-radius: 12px;
`;

const BuyButton = styled.button`
    background: #8C1C1C;
    color: #FFF;
    border-radius: 12px;
    padding: 8px 0;
    width: 100%;
    margin-top: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.3s;

    &:hover {
        background: #8C1C1C12;
    }
`;

const TextWrapper = styled.p`
    gap: 5px;
    display: flex;
    align-items: start;
`;

const TextIcon = styled.span`
    font-size: 15px;
    font-weight: 400;
    color: #FFFFFF;
    opacity: 0.8;
`;

const SideBar = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const { token } = useSelector((state) => state.auth);
    const { mainVideo } = useSelector((state) => state.courses);
    const { token: registerToken } = useSelector(state => state.form);

    useEffect(() => {
        dispatch(getMainVideo())
    }, [dispatch]);

    const courseIncludes = [
        { icon: <Download />, text: t('course_details.lessons', { count: 6 }) },
        { icon: <Vector />, text: t('course_details.next_lesson', { date: '17.12.2024', time: '19:00' }) },
        { icon: <Phone />, text: t('course_details.mobile_access') },
        { icon: <Certification />, text: t('course_details.certificate') }
    ];

    const currentPrice = mainVideo?.new_price
    
    const oldPrice = mainVideo?.old_price

    return (
        <SidebarContainer>
            <SidebarWrapper>
                <p className='font-normal text-[14px] text-[#EAEAEA]'>{t('course_details.full_course')}</p>
                <h2 className='font-semibold text-[36px] flex items-center gap-3 text-white'>
                    {t('currency')}{Math.round(currentPrice) || 0}
                    <span className='line-through text-[17px] text-[#EAEAEA] opacity-80 text-sm'>
                        {t('currency')}{Math.round(oldPrice) || 0}
                    </span>
                </h2>
                <Link to={token || registerToken ? '/passingcourse/1' : '/signin'}>
                    <BuyButton className='text-base'>{t('course_details.buy')}</BuyButton>
                </Link>

                <h3 className='py-3 font-semibold text-white'>{t('course_details.eligibility')}</h3>
                <TextWrapper>
                    <Info />
                    <TextIcon>
                        <p className='text-[#EAEAEA]'>{t('course_details.eligibility_description')}</p>
                    </TextIcon>
                </TextWrapper>

                {/* <div className="mt-6">
                    <h3 className='py-3 font-semibold text-white'>{t('course_details.includes')}</h3>
                    <div className="space-y-3">
                        {courseIncludes.map((item, index) => (
                            <TextWrapper key={index}>
                                {item.icon}
                                <TextIcon style={{color: "#EAEAEA !important"}}>{item.text}</TextIcon>
                            </TextWrapper>
                        ))}
                    </div>
                </div> */}
            </SidebarWrapper>
            <SidebarWrapper className='mt-4'>
                <p className='font-normal text-[14px] text-[#EAEAEA]'>The courses are divided into three terms and delivered in full within a term. Each term is of two months' duration as follows:</p>
                <h3 className='py-3 font-semibold text-white'>Michaelmas Term:</h3>
                <ul style={{
                    paddingLeft: "20px",
                    listStyleType: "initial"
                }}><li className="text-[#EAEAEA]">Starts 1 October</li><li className="text-[#EAEAEA]">Ends 30 November</li></ul>
                <h3 className='py-3 font-semibold text-white'>Lent Term:</h3>
                <ul style={{
                    paddingLeft: "20px", listStyleType: "initial"
                }}><li className="text-[#EAEAEA]">Starts 1 May</li><li className="text-[#EAEAEA]">Ends 30 June</li></ul>
            </SidebarWrapper>
        </SidebarContainer>
    );
};

export default SideBar;